<a
  [routerLink]="['/', 'profile']"
>
  <img class="profile-avatar" *ngIf="avatar" [src]="avatar" alt="Avatar">
  <span class="profile-name">{{profileName}}</span>
</a>
